export const version = 'kunde-v1.20.0-SNAPSHOT-a68432a2c74905132b6d4a8ae6887f5c5aaa984c';